import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-router-link-link-content',
  imports: [],
  templateUrl: './router-link-link-content.component.html',
  styleUrl: './router-link-link-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouterLinkLinkContentComponent {}
